import React from 'react'

import SignOut from '../../components/SignOut'

const LogoutTemplate: React.FunctionComponent = () => <SignOut />

export default LogoutTemplate
